export { Dictionary, replace } from './Dictionary'
export * from './DictionaryTypes'
